const optimizedResize = require('utilities/optimizedResize');
let value = 'small';

let refreshValue = () => {
	let body = document.body;
	let bodyBefore = window.getComputedStyle(body, ':before');
	let size = bodyBefore.getPropertyValue('content').replace(/\"/g, '');

	value = size;
};

optimizedResize.add(refreshValue);

refreshValue();

const isLargeScreen = () => value === 'large';
const isMediumScreen = () => value === 'medium';
const isSmallScreen = () => value === 'small';

module.exports = {
	refreshValue,
	isLargeScreen,
	isMediumScreen,
	isSmallScreen
};
